import React, { Component } from 'react';
import ApiClient from '../libs/apiClient';
import Tooltip from './ToolTip';
const apiClient = ApiClient.getInstance();

class DataXML extends Component{
    constructor(props) {
        super(props);
        this.state = {
            firstObject: {},
            secondObject: {}
        }
    }

    componentDidMount(){
        this.getDataXML();
    }

    getDataXML = async () => {
        const { newOrderModel } = this.props;
        let data = {
            docNum: newOrderModel.DocNum,
            serie: newOrderModel.SerieCode,
            serieName: newOrderModel.SerieName,
        }
        const response = await apiClient.getDataXML(data);
        if(response.status === 1){
            this.setState({ firstObject: response.data.firstObject, secondObject: response.data.secondObject});            
        }
    }

    renderInput = (data) => {
        const { index, key, value} = data;
        let flagObject = false;

        const Element = value.length > 50 ? 'textarea' : 'input';

        if (typeof value === 'object' ){
            flagObject = true;     
        }

        return(
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <span className="input-group-text font-weight-bold" id="basic-addon1">{key}</span>
                </div>
                {!flagObject ?
                    <Element
                        type="text"
                        className="form-control input-sm"
                        id={key + index}
                        disabled="false"
                        value={value}
                    />
                :
                    <Tooltip
                        tips={value}
                        view={'XML'}
                        position={'up'} 
                    />
                }
            </div>
        );
    }

    render() {
        const { firstObject, secondObject} = this.state;
        return (
            <div className="row">
                {(Object.entries(firstObject).length === 0 && Object.entries(secondObject).length === 0) ? (
                    <p className="col-12 textxlm">No hay un XML disponible para este documento</p>
                ) : (
                    <>
                        <div className="col-6">
                            {Object.entries(firstObject).length > 0 && (
                                Object.entries(firstObject).map(([key, value], index) => (
                                    <React.Fragment key={index}>
                                        {this.renderInput({key, value, index})}
                                    </React.Fragment>
                                ))
                            )}
                        </div>
                        <div className="col-6">
                            {Object.entries(secondObject).length > 0 && (
                                Object.entries(secondObject).map(([key, value], index) => (
                                    <React.Fragment key={index}>
                                        {this.renderInput({key, value, index})}
                                    </React.Fragment>
                                ))
                            )}
                        </div>
                    </>
                )}
            </div>
        );
    }
}
export default DataXML;